import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { RadioButton } from '../RadioButton/RadioButton'
import { Chosen } from '../chosen/Chosen'
import { Link } from '../link/Link'
import { InputContainer } from '../inputContainer/InputContainer'
import { Button } from '../Button/Button'
import { FontAwesomeIcon } from '../icons/FontAwesomeIcon'
import { ModalHead, ModalBody, ModalFoot } from '../Modal/Modal'
import { MessageBox } from '../MessageBox/MessageBox'

import '../Modal/Modal.scss'

const DATA_ATTR_TEST = 'manage-recipients-groups'

export const ManageRecipientWithGroups = ({
  selectGroup,
  groupsChosen,
  groupsChosenLimit,
  groupsChosenLoading,
  handleChosenChange,
  handleChosenSelect,
  callbackNewGroup,
  callbackCancel,
  callbackApply,
  label,
  createGroupError,
  createGroupInvalidMessage,
  onChangeNewGroup,
  children,
}) => {
  const [newGroupVisible, setNewGroupVisible] = useState(false)
  const [newGroupName, setNewGroupName] = useState('')
  const [checkCopy, setCheckCopy] = useState(true)
  const [group, setGroup] = useState(null)

  useEffect(() => {
    setGroup(selectGroup)
  }, [selectGroup])

  // se seleziono gruppo e non presente in elenco opzioni => aggiungo a opzioni
  const tmp =
    group && groupsChosen.findIndex((g) => g.value === group.value) === -1
      ? [group, ...groupsChosen]
      : groupsChosen
  // se modalità copia => non accettabile opzione "nessun gruppo"
  const tmp2 = checkCopy ? tmp.filter((g) => g.value !== 0) : tmp

  const propsChosenGroupMove = {
    value: group ? group.value : null,
    className: 'test-statManageRecipientReport-ChosenRecipientGroupCopy',
    isSearchable: true,
    onChange: onChangeChosenGroup,
    options: tmp2,
    placeholder: label.placeholderChosenGroup,
    limitSearch: groupsChosenLimit && !groupsChosenLoading,
    limitSearchText: label.limitSearchTextChosenGroup,
    onInputChange: handleChosenChange,
    filterOptionMethod: 'contains',
    isLoading: groupsChosenLoading,
  }

  const inputNewGroup = {
    value: newGroupName,
    type: 'text',
    placeholder: label.placeholderInputNewGroup,
    inputClassName: 'test-statManageRecipientReport-NewRecipientGroupName',
    onChange: onChangeInputNewGroup,
    enablePressEnter: true,
    pressEnterCallback: onClickSave,
    isInvalid: !!createGroupInvalidMessage,
    invalidMessage: createGroupInvalidMessage,
  }

  function onChangeChosenGroup(e) {
    if (handleChosenSelect && typeof handleChosenSelect === 'function') {
      handleChosenSelect(e)
    }
    setGroup(e)
  }

  function onChangeInputNewGroup(e) {
    setNewGroupName(e.target.value)
    onChangeNewGroup(e)
  }

  function onChangeRadio() {
    setNewGroupName('')
    setCheckCopy(!checkCopy)
    setNewGroupVisible(false)
  }

  function onClickSave() {
    callbackNewGroup(newGroupName)
    setNewGroupName('')
  }

  function onClickApply() {
    callbackApply({
      groupSelected: group ? group.value : null,
      checkCopy,
    })
  }

  const isValid = group
    ? checkCopy
      ? group.value > 0
      : group.value > -1
    : false

  return (
    <>
      <ModalHead title={label.title} />

      <ModalBody>
        <div className='row'>
          {createGroupError && (
            <MessageBox type='error'>{createGroupError}</MessageBox>
          )}
          <RadioButton
            className='test-statManagerRecipientReport-radioRecipientCopy m-bottom-thin'
            name='radio-button'
            label={label.copyGroup}
            value='copy'
            checked={checkCopy}
            onChange={onChangeRadio}
            data-mu-test={`${DATA_ATTR_TEST}__copy__radio`}
          />
          {checkCopy && (
            <>
              <div className='row m-bottom-thin indent-radio'>
                <Chosen
                  {...propsChosenGroupMove}
                  data-mu-test={`${DATA_ATTR_TEST}__copy__select`}
                />
              </div>
              <div className='row m-bottom-thin indent-radio'>
                <Link
                  className='textlink-highlight'
                  onClick={() => setNewGroupVisible(!newGroupVisible)}
                >
                  <FontAwesomeIcon icon={newGroupVisible ? 'minus' : 'plus'} />
                  &nbsp;{label.createNewGroup}
                </Link>
              </div>
              {newGroupVisible && (
                <div className='row m-bottom-0 indent-radio'>
                  <div className='col-xs-8 p-left-0'>
                    <InputContainer
                      {...inputNewGroup}
                      data-mu-test={`${DATA_ATTR_TEST}__copy__input--new-group-name`}
                    />
                  </div>
                  <div className='col-xs-4 p-right-0'>
                    <Button
                      kind='primary'
                      disabled={!newGroupName}
                      onClick={onClickSave}
                      data-mu-test={`${DATA_ATTR_TEST}__copy__button--save-new-group`}
                    >
                      {label.saveNewGroup}
                    </Button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        <div className='row'>
          <RadioButton
            name='radio-button'
            label={label.moveGroup}
            value='move'
            checked={!checkCopy}
            onChange={onChangeRadio}
            data-mu-test={`${DATA_ATTR_TEST}__move__radio`}
          />
          <p className='note indent-radio m-bottom-thin m-top-thin'>
            {label.moveRecipientGroupAlert}
          </p>
          {!checkCopy && (
            <>
              <div className='row m-bottom-thin indent-radio'>
                <Chosen
                  {...propsChosenGroupMove}
                  data-mu-test={`${DATA_ATTR_TEST}__move__select`}
                />
              </div>
              <div className='row m-bottom-thin indent-radio'>
                <Link
                  className='textlink-highlight'
                  onClick={() => setNewGroupVisible(!newGroupVisible)}
                >
                  <FontAwesomeIcon icon={newGroupVisible ? 'minus' : 'plus'} />
                  &nbsp;{label.createNewGroup}
                </Link>
              </div>
              {newGroupVisible && (
                <div className='row m-bottom-0 indent-radio'>
                  <div className='col-xs-8 p-left-0'>
                    <InputContainer
                      {...inputNewGroup}
                      data-mu-test={`${DATA_ATTR_TEST}__move__input--new-group-name`}
                    />
                  </div>
                  <div className='col-xs-4 p-right-0'>
                    <Button
                      kind='primary'
                      disabled={!newGroupName}
                      onClick={onClickSave}
                      data-mu-test={`${DATA_ATTR_TEST}__move__button--save-new-group`}
                    >
                      {label.saveNewGroup}
                    </Button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        {children}
      </ModalBody>

      <ModalFoot>
        <Button
          kind='primary'
          data-mu-test='button-apply'
          disabled={!isValid}
          onClick={onClickApply}
        >
          {label.apply}
        </Button>
        <Button
          kind='neutral'
          data-mu-test='button-cancel'
          onClick={callbackCancel}
        >
          {label.cancel}
        </Button>
      </ModalFoot>
    </>
  )
}

ManageRecipientWithGroups.defaultProps = {}

ManageRecipientWithGroups.propTypes = {
  selectGroup: PropTypes.object,
  groupsChosen: PropTypes.array,
  groupsChosenLimit: PropTypes.bool,
  groupsChosenLoading: PropTypes.bool,
  handleChosenChange: PropTypes.func,
  handleChosenSelect: PropTypes.func,
  callbackNewGroup: PropTypes.func,
  callbackCancel: PropTypes.func,
  callbackApply: PropTypes.func,
  label: PropTypes.object,
  createGroupError: PropTypes.string,
  createGroupInvalidMessage: PropTypes.string,
  onChangeNewGroup: PropTypes.func,
}
